import { Box, Container, Typography } from '@mui/material';

import type { TextBlockContent } from '@/types/database';

export function TextBlockView({ content }: { content: TextBlockContent }) {
  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="md">
        <Typography variant={content.variant ?? 'body1'} align={content.align ?? 'left'} sx={{ lineHeight: 1.8 }}>
          {content.content}
        </Typography>
      </Container>
    </Box>
  );
}
